import useWorkspaceSelected from 'Hooks/useWorkspaceSelected';

export default function useHasEnabledTaxAuthority() {
    const { workspace, isLoading } = useWorkspaceSelected();

    const hasEnabledTaxAuthority =
        ['verifactu', 'ticketbai'].includes(workspace?.tax_authority) && workspace?.tax_authority_status === 'ok';

    const taxAuthority = hasEnabledTaxAuthority ? workspace.tax_authority : null;

    return { hasEnabledTaxAuthority, taxAuthority, isLoading };
}
